import React from "react";
import Slider from "infinite-react-carousel";
import { Link } from "react-router-dom";
import { Button } from "..";
import "./servicesCarousel.css";

function ServiceCarousel({ className, list }) {
  const env = process.env.NODE_ENV;

  let classes = ["wrapper-carousel", className].join(" ");

  let services = list.map((item, idx) => (
    <div className="name-icon" key={idx}>
      <a
        className="carousel-item-link"
        href={item.url}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className={`service-icon ${item.image}`}></div>
        <h3>{item.title}</h3>
      </a>
      <Link to={item.demoUrl}>
        <Button
          secondary
          style={{ transform: "scale(.8)" }}
          disabled={!("demoUrl" in item)}
          animation="swipe"
        >
          {"demoUrl" in item ? "مشاهده دمو" : "بزودی"}
        </Button>
      </Link>
    </div>
  ));

  const settings = {
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    wheel: true,
    autoplay: env === "development" ? false : true,
    autoplaySpeed: 2000,
  };

  const settingsMobile = {
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    wheel: true,
    autoplay: env === "development" ? false : true,
    autoplaySpeed: 2000,
  };

  return (
    <div className={classes}>
      <h2>سرویس‌های ما</h2>
      <div className="main-carousel">
        <Slider
          {...settingsMobile}
          ref={(ele) => {
            window.SlimpleSlider = ele;
          }}
          className="mobile"
          draggable={false}
        >
          {services}
        </Slider>

        <Slider
          {...settings}
          ref={(ele) => {
            window.SlimpleSlider = ele;
          }}
          className="web"
          draggable={false}
        >
          {services}
        </Slider>
      </div>
    </div>
  );
}

export default ServiceCarousel;
